import React from "react";

interface ITextContentProps {
	content: string;
	style?: React.CSSProperties;
}

interface ITextStoreRenderer {
	id: number | string;
	data: string;
	html: boolean;
}

export const HTML: React.SFC<ITextContentProps> = ({ content, style }) => {
	return <div dangerouslySetInnerHTML={{ __html: content }} style={style} />;
};

export const TextStoreRenderer: React.SFC<ITextStoreRenderer> = ({ data, html }) => {
	if (html) {
		return <HTML content={data} />;
	}
	return <div>{data}</div>;
};



// WEBPACK FOOTER //
// ./src/common/fragments/TextContent.tsx